import React from 'react';
import { IconProps } from 'shared/icons/iconProps';
import IconActiveStar from 'shared/icons/favourite/iconActiveStart';
import IconInactiveStar from 'shared/icons/favourite/iconInactiveStar';

export default function FavoriteIconController({
  isFavourite,
  ...other
}: IconProps & { isFavourite: boolean }) {
  return isFavourite ? (
    <IconActiveStar {...other}></IconActiveStar>
  ) : (
    <IconInactiveStar {...other}></IconInactiveStar>
  );
}
